import { Box, Button } from "@mui/material";
import { useState } from "react";
import { useSubscriptionDelete } from "@arelia-components/SubscriptionDetails/useSubscriptionDetailsAPI";
import RemoveSubscriptionConfirmationDialog from "./RemoveSubscriptionConfirmationDialog";
import PaidSubscriptionWarningDialog from "./PaidSubscriptionWarningDialog";
import { toast } from "sonner";

type Props = {
  userId: string;
  removeSubAvailable: boolean;
  isFreePlan: boolean;
};

export default function SubscriptionInfoActionsAdmin({ userId, removeSubAvailable, isFreePlan }: Props) {
  const [openRemoveSubDialog, setOpenRemoveSubDialog] = useState(false);
  const [openPaidWarningDialog, setOpenPaidWarningDialog] = useState(false);
  const { mutate: deleteSubscription } = useSubscriptionDelete(userId);

  const closeRemoveSubDialog = (confirmed: boolean) => {
    setOpenRemoveSubDialog(false);

    if (confirmed) {
      if (!isFreePlan) {
        setOpenPaidWarningDialog(true);
      } else {
        performDelete(false);
      }
    }
  };

  const closePaidWarningDialog = () => {
    setOpenPaidWarningDialog(false);
  };

  const confirmPaidWarning = () => {
    setOpenPaidWarningDialog(false);
    performDelete(true);
  };

  const performDelete = (forcePaidRemoval: boolean) => {
    deleteSubscription(forcePaidRemoval, {
      onSuccess: () => {
        toast.success("Subscription removed successfully");
      },
      onError: () => {
        toast.error("Failed to remove subscription");
      }
    });
  };

  return (
    <Box sx={styles.actions}>
      {removeSubAvailable && (
        <Button
          variant="contained"
          color="error"
          onClick={() => setOpenRemoveSubDialog(true)}
        >
          Remove Subscription
        </Button>
      )}

      {openRemoveSubDialog && (
        <RemoveSubscriptionConfirmationDialog
          onClose={closeRemoveSubDialog}
        />
      )}

      {openPaidWarningDialog && (
        <PaidSubscriptionWarningDialog
          onClose={closePaidWarningDialog}
          onConfirm={confirmPaidWarning}
        />
      )}
    </Box>
  );
}

const styles = {
  actions: {
    display: "flex",
    flexDirection: "row" as const,
    justifyContent: "center",
    gap: "16px",
    width: "100%"
  }
};
